import * as React from 'react';
import './ReturnsRow.scss';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IEligibleItem } from 'src/services/returns/typings';
import isNumber from 'src/utils/isNumber';
import hasComma from 'src/utils/hasComma';
import IconMessage from 'src/components/common/IconMessage';
import i18n from 'src/translation/i18n';
import AlertCustom from 'src/components/common/AlertCustom';
interface IReturnsRowProps {
  partToReturn: IEligibleItem;
  removeItemFromReturn: (id: number) => void;
  editPartFromReturnList: (part: IEligibleItem) => void;
  isShowTableHistoryInfoForRow:boolean;
}

const ReturnsRow: React.FC<IReturnsRowProps> = props => {
  const { partToReturn, removeItemFromReturn, editPartFromReturnList,isShowTableHistoryInfoForRow } = props;
  const [isEditEnabled, setIsEditEnabled] = React.useState<boolean>(false);
  const [returnQty, setReturnQty] = React.useState<string>(
    String(partToReturn.returnQuantity)
  );
  const [reason, setReturnReason] = React.useState<string>(partToReturn.reason);
  const [isShowHistoryInfo, setIsShowHistoryInfo] = React.useState<boolean>(false);

  React.useEffect(()=>{
    if(partToReturn.noOfTimesPartInvoicedInLast90Days>1){
      setIsShowHistoryInfo(true);
    }
  },[])
  
  const handleEdit = () => {
    if (isEditEnabled) {
      editPartFromReturnList({
        ...partToReturn,
        returnQuantity: Number(returnQty),
        reason
      });
    }

    setIsEditEnabled(!isEditEnabled);
  };

  const handleCloseAlert = () => {
    setIsShowHistoryInfo(false)
  }

  const handleChangeReturnQty = (e: any) => {
    const qty = e.target.value;

    if (isNumber(qty) && qty <= partToReturn.availableQuantity) {
      setReturnQty(qty);
    }
  };

  const handleChangeReason = (e: any) => {
    if (!hasComma(e.target.value)) {
      setReturnReason(e.target.value);
    }
  };

  const isValidQuantity = (): boolean => {
    return Number(returnQty) > 0;
  };

  return (
    <div className="rp-returns-row">
      <div className="container-fluid">
        <div className="row">
          <div className="d-flex align-items-center col-16">
            <p className="rp-returns-row-container">
              {partToReturn.partNumber}
            </p>
          </div>
          <div className="d-flex align-items-center col-14">
            <p className="rp-returns-row-container">
              {partToReturn.invoiceNumber}
            </p>
          </div>
          <div className="d-flex align-items-center col-9">
            <p className="rp-returns-row-container price">
              {localeFormatingInstance.formatCurrency(partToReturn.price)}
              {partToReturn.hasCoreIncluded && (
                <IconMessage
                  icon={'rpds-error'}
                  isIconInline={true}
                  message={'This price includes a Core Charge'}
                />
              )}
            </p>
          </div>
          <div className="d-flex align-items-center col-11">
            {isEditEnabled ? (
              <>
                <input
                  value={returnQty}
                  onChange={handleChangeReturnQty}
                  className="rp-returns-row-container-input price"
                  type="text"
                />
                <p className="rp-returns-row-container-return-quantity-total">
                  / {partToReturn.availableQuantity}
                </p>
              </>
            ) : (
              <p className="rp-returns-row-container">
                {partToReturn.returnQuantity}
              </p>
            )}
          </div>
          <div className="d-flex align-items-center col-14">
            <p className="rp-returns-row-container">
              {partToReturn.returnFee ? partToReturn.returnFee : '0'}%
            </p>
          </div>
          <div className="d-flex align-items-center col-17">
            {isEditEnabled ? (
              <input
                value={reason}
                onChange={handleChangeReason}
                className="rp-returns-row-container-input"
                type="text"
                maxLength={60}
              />
            ) : (
              <p className="rp-returns-row-container">{partToReturn.reason}</p>
            )}
          </div>
          <div className="d-flex align-items-center d-flex justify-content-end col-19">
            <div className="rp-returns-row-buttons">
              <div
                onClick={isValidQuantity() ? handleEdit : null}
                className={`rp-returns-row-button-edit ${
                  !isValidQuantity() ? 'disabled' : ''
                }`}
              >
                {isEditEnabled ? (
                  <>
                    <i className="rpds-check-circle rp-returns-row-button-icon" />
                    <p className="rp-returns-row-button-text">
                      {' '}
                      {i18n.t('common.save')}{' '}
                    </p>
                  </>
                ) : (
                  <>
                    <i className="rpds-edit rp-returns-row-button-icon" />
                    <p className="rp-returns-row-button-text">
                      {i18n.t('common.editActionTxt')}
                    </p>
                  </>
                )}
              </div>
              <div
                className="rp-returns-row-button-remove"
                onClick={() => removeItemFromReturn(partToReturn.id)}
              >
                <i className="rpds-remove-circle rp-returns-row-button-icon" />
                <p className="rp-returns-row-button-text">
                  {i18n.t('common.removeAction')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {isShowHistoryInfo && isShowTableHistoryInfoForRow &&
        <div className="row">
        <AlertCustom
          type="info"
          styleClass="rp-return-row-history-info--alert"
          icon={'icon="rpds-check-circle"'}
          handleCloseAlert={handleCloseAlert}
          removeItemFromReturn={removeItemFromReturn}
          handleTableCloseAlert={null}
          removeAllPartsFromCart={null}
          id={partToReturn.id}
          message={`You have used part ${partToReturn.partNumber} recently ${partToReturn.noOfTimesPartInvoicedInLast90Days} times with ${partToReturn.partQtyOrdered} quantity`}
        />
        </div>
        }  
      </div>
    </div>
  );
};

export default ReturnsRow;
